import useGlobalState from './package/useGlobalState';
export { default as GlobalStateProvider } from './package/GlobalStateProvider';

export default useGlobalState;
